import React, { useState } from 'react';

import { Modal, Button } from '@companycam/slab-web';

import { translate } from 'javascripts/translations/i18n';
import { useModal } from 'components/shared/hooks';
import ProjectSelect from 'components/reviews/reviewRequests/ProjectSelect';
import { type Project } from 'components/reviews/reviewRequests/types';
import useShowcaseTableData from 'components/showcase/hooks/useShowcaseTableData';
import { ModalHeader } from 'components/publicProfile/CommonComponents';

const SelectShowcaseProjectModal = () => {
  const [project, setProject] = useState<Project | null>(null);
  const { refetch } = useShowcaseTableData();

  const { hideModal, showModal, Modal: ModalConstants } = useModal();

  const handleSelectedProject = () =>
    showModal(ModalConstants.SHOWCASE_WIZARD, {
      existingShowcaseProject: null,
      isEditing: false,
      projectDatabaseId: project.node.databaseId,
      afterCreate: refetch,
    });

  const filterProjectsWithShowcase = (p: Project) => !p.node.hasShowcaseProject;

  return (
    <Modal
      title={translate('common.chooseAProject')}
      size="small"
      headerComponent={
        <ModalHeader headerTitle={translate('common.chooseAProject')} />
      }
      bodyStyle={{
        paddingBottom: 'var(--cc_size_spacing_xl)',
        paddingRight: 'var(--cc_size_spacing_xl)',
        paddingLeft: 'var(--cc_size_spacing_xl)',
      }}
      isOpen
      onClose={hideModal}
      footerActions={
        <>
          <Button onClick={hideModal}>{translate('common.cancel')}</Button>
          <Button
            color="primary"
            onClick={handleSelectedProject}
            disabled={!project}
          >
            {translate('common.continue')}
          </Button>
        </>
      }
    >
      <ProjectSelect
        onProjectSelect={(p) => setProject(p)}
        selectedProject={project}
        placeholderText={translate(
          'project.reviews.reviewsHub.selectShowcaseProject',
        )}
        filterProjects={filterProjectsWithShowcase}
      />
    </Modal>
  );
};

export default SelectShowcaseProjectModal;
